module.exports = __webpack_public_path__ + "static/media/GC01@l.01dbc48d.jpg";